import { FieldArray, useFormikContext } from 'formik'
import { useParams,useNavigate  } from 'react-router-dom'
import { RotateCcw } from 'lucide-react'
import React, { useState, useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'

import { useOrderSave, useOrderUpdate } from 'store/server/useOrder'
import DisliSayisiDetayModal from 'components/form/modals/DisliSayisiDetayModal'
import { Button as UIButton } from 'components/ui/button';

import { Input } from 'components/form/input'
import { Input as NoFormInput } from 'components/ui/input'
import { Button } from 'components/ui/button'
import { Separator } from 'components/ui/separator'
import { SelectReferanceCode } from 'components/form/compobox/select-referance-code'
import Sizes from './Sizes'
import SizesHome from './Sizes/SizeHome'
import Symbol from './Symbol'
import { RxCross1 } from "react-icons/rx";
import { Form, Input as AntInput, Button as AntButton, Select, message, Modal, Table,Tooltip  } from 'antd'
import requests from 'service/api'
import Fabric from './Fabric'
import AdditionalInstructions from './Addition/AdditionalInstructions'
import WashingAdditionalInstructions from './Addition/WashingAdditionalInstructions'
import { Link } from 'react-router-dom'
import { X } from 'lucide-react'
import { toast } from 'components/ui/use-toast'
import { useAuth } from 'store/client/authStore'

const { Option } = Select

export default function WashingInstructions({ currentTab,brannd }) {
  const { values, setFieldValue } = useFormikContext()
  const { mutate: saveOrder, isPending } = useOrderSave()
  const { mutate: updateOrder, isPending: isPendingUpdate } = useOrderUpdate()
  const { brand, orderNo, dept, subDept } = useParams()
  const brandId = brand.split('_')[0];
  const [isDisliModalVisible, setIsDisliModalVisible] = useState(false)
  const { user } = useAuth()
  const [departmantIDD, setdepartmantIDD] = useState('')
  const [ifinch,setifinch] = useState(false)
  const navigate = useNavigate();

  const handleDisliModalClose = () => {
    setIsDisliModalVisible(false)
  }

  const handleDisliModalOpen = () => {
    setIsDisliModalVisible(true)
  }
  const ClearableSelect = ({ value, onChange, options, placeholder, form, name }) => {
    const handleClear = () => {
      // Seçili değeri sıfırla
      form.setFieldsValue({ [name]: undefined });
      onChange(undefined);
    };


    return (
      <div style={{ position: "relative" }}>
  
        <Select
          showSearch
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          style={{ width: '100%' }}
          filterOption={(input, option) =>
            option?.children?.toLowerCase().includes(input.toLowerCase())
          }
          suffixIcon={<span style={{ display: 'none' }}></span>} // Arama ikonunu gizler
  
        >
          {options.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
        {value && (
          <RxCross1
            onClick={handleClear}
            style={{
              position: "absolute",
              right: 10,
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "red",
            }}
          />
        )}
      </div>
    );
  };
  const DrawerContent4 = () => {
    const [form4] = Form.useForm()
    const [GrafDurum, setGrafDurum] = useState([]) // Tablo verileri için state
    const [GrafDurumOld, setGrafDurumOld] = useState([]) // Tablo verileri için state
    const [searchText, setSearchText] = useState('') // Tablo verileri için state
    const [isRowModalVisible, setIsRowModalVisible] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null); // Seçilen satırdaki veri
    const [colordsx, setcolordsx] = useState([
      { code: "W", text: " WHITE" },
      { code: "B", text: "BLACK" },
    ]);

    // React Query ile veri çekimi
    const { data, isFetched, refetch } = useQuery({
      queryKey: ['/list', 'referance', 'YIKAMA TALİMATI'],
      queryFn: async () => {
        const { data } = await requests.referance.list({ labelCategory: 'YIKAMA TALİMATI' })
        return data
      },
      placeholderData: []
    })

    // useEffect ile her girişte veri yeniden çekilsin
    useEffect(() => {
      if (data && data.length > 0) {
        console.log('Refetched Data:', data) // Gelen veriyi konsola yazdır
        const isWasgingLabel = data.filter(
          (item) => item.labelCategory === 'YIKAMA TALİMATI'
        )

        setGrafDurum(isWasgingLabel)
        setGrafDurumOld(isWasgingLabel)
      }
    }, [data])

    // Uyarı etiketleri için filtreleme

    const onSipNoFinishGrafik = (values) => {
      const requiredFields = ['code', 'name', 'height','width', 'kod', 'a', 'backgroundColor'];
      const emptyFields = requiredFields.filter((field) => !values[field]);

      // Eğer boş alan varsa hata döndür
      if (emptyFields.length > 0) {
        const fieldNames = {
          code: 'Kod',
          name: 'İsim',
          height: 'Yükseklik',
          width:'Genişlik',
          kod: 'Kod',
          a: 'A Değeri',
          backgroundColor: 'Arkaplan Rengi',
        };
        const missingFields = emptyFields.map((field) => fieldNames[field]).join(', ');
        message.error(`Lütfen şu alanları doldurun: ${missingFields}`);
        return; // Devam etme
      }
      
      Modal.confirm({
        title: 'Referans eklemek istiyor musunuz?',
        content: 'Evet dediğinizde Referans bilgileri eklenecektir.',
        okText: 'Evet',
        cancelText: 'Hayır',
        onOk: async () => {
          try {
            const response = await requests.order.addReferenceCode({
              code: values.code,
              name: values.name,
              height: values.height,
              width:values.width,
              subDepartmentId: "6588e3b13feccdb13e955a47",
              kod: values.kod,
              labelCategory: "YIKAMA TALİMATI",
              labelType: "YIKAMA TALİMATI",
              a: values.a,
              backgroundColor: values.backgroundColor,
              shape: '',
              shape2: ''
            })

            if (response.status === 200) {
              Modal.success({
                title: 'Başarılı',
                content: 'Sipariş başarıyla güncellendi.'
              })
              console.log("dataşöylegelid",response.data)
              setGrafDurum(response.data.data) // Yeni veriyi tabloya ekle
              setGrafDurumOld(response.data.data) // Yeni veriyi tabloya ekle
              refetch(); // Refetch'i tetikle
            }

          } catch (error) {
            console.error('Hata oluştu:', error)
            Modal.error({
              title: 'Hata',
              content: 'Sipariş güncellenirken bir hata oluştu.'
            })
          }
        },
        onCancel() {
          console.log('Güncelleme iptal edildi.')
        }
      })
    }
    const handleReferanceSil = (id) => {
      Modal.confirm({
        title: 'Referansı silmek güncellemek istiyor musunuz?',
        content: 'Referans silindiğinde geri alınmayacaktır.',
        okText: 'Evet',
        cancelText: 'Hayır',
        onOk: async () => {
          try {
            const response = await requests.order.deleteReferenceCode({
              id: id,
            })

            if (response.status === 200) {
              Modal.success({
                title: 'Başarılı',
                content: 'Sipariş başarıyla güncellendi.'
              })

              setGrafDurum(response.data.data) // Yeni veriyi tabloya ekle
              setGrafDurumOld(response.data.data) // Yeni veriyi tabloya ekle
              refetch(); // Refetch'i tetikle

            }
          } catch (error) {
            console.error('Hata oluştu:', error)
            Modal.error({
              title: 'Hata',
              content: 'Sipariş güncellenirken bir hata oluştu.'
            })
          }
        },
        onCancel() {
          console.log('Güncelleme iptal edildi.')
        }
      })
    };
  
    const handleSearchmini = (value) => {
      console.log("valueeeee",value)
      setSearchText(value);
      const filtered = GrafDurum.filter((item) => {
        return (
          (item.code && item.code.includes(value)) || // code zaten string
          (item.height && String(item.height).includes(value)) || // height string'e dönüştürülüyor
          (item.width && String(item.width).includes(value)) || // width string'e dönüştürülüyor
          (item.name && item.name.includes(value)) // name zaten string
        );
      });
      setGrafDurum(value ? filtered : GrafDurumOld);
      
  
    };
    const minicolumnsgrafikdurum = [
      {
        title: 'Kod',
        dataIndex: 'code',
        key: 'code',
        render: text => <span style={{ fontSize: '12px' }}>{text}</span>

      },
      {
        title: 'İsim',
        dataIndex: 'name',
        key: 'name',
        render: (text) => (
          <Tooltip title={text}>
            <span style={{ fontSize: '12px' }}>
              {text.length > 20 ? `${text.substring(0, 20)}...` : text}
            </span>
          </Tooltip>
        ),

      },
      {
        title: 'Width',
        dataIndex: 'width',
        key: 'width',
        render: text => <span style={{ fontSize: '12px' }}>{text}</span>

      },
      {
        title: 'Height',
        dataIndex: 'height',
        key: 'height',
        render: text => <span style={{ fontSize: '12px' }}>{text}</span>

      },
      {
        title: 'Renk',
        dataIndex: 'backgroundColor',
        key: 'backgroundColor',
        render: text => <span style={{ fontSize: '12px' }}>{text}</span>

      },
      {
        title: 'Açıklamakod',
        dataIndex: 'kod',
        key: 'kod',
        render: text => <span style={{ fontSize: '12px' }}>{text}</span>

      }, // Fazladan virgül bu satırdan kaldırıldı
      {
        title: 'İşlemler',
        key: 'actions',
        render: (text, record) => (
          <div
          onClick={(e) => {
        e.stopPropagation(); // Tıklama olayını üst katmanlara taşımayı engeller
        handleReferanceSil(record.id); // Silme işlemini tetikler
      }}
          style={{
            cursor: 'pointer', // Tıklanabilir hissiyatı verir
            padding: '5px 10px',
            backgroundColor: 'red',
            color: 'white',
            border: '1px solid red',
            borderRadius: '4px',
            display: 'inline-block',
            textAlign: 'center',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#cc0000'; // Hover rengi
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'red'; // Orijinal renk
          }}
        >
          Referans Sil
        </div>
        ),
      },
    ];
    const handleRowGrafDurumClick = (record) => {
      setSelectedRowData(record); // Satırdaki veriyi state'e aktar
      console.log("recoo",record);
      setIsRowModalVisible(true); // Modalı aç
    };

    const handleRowModalSave = () => {
      // Kaydetme işlemleri burada yapılır
      console.log("Kaydedilen Veri:", selectedRowData);
 
      const requiredFields = ['code', 'name', 'height','width', 'kod', 'a', 'backgroundColor'];
      const emptyFields = requiredFields.filter((field) => !selectedRowData[field]);

      // Eğer boş alan varsa hata döndür
      if (emptyFields.length > 0) {
        const fieldNames = {
          code: 'Kod',
          name: 'İsim',
          height: 'Yükseklik',
          width:'Genişlik',
          kod: 'Kod',
          a: 'A Değeri',
          backgroundColor: 'Arkaplan Rengi',
        };
        const missingFields = emptyFields.map((field) => fieldNames[field]).join(', ');
        //message.error(`Lütfen şu alanları doldurun: ${missingFields}`);
        return; // Devam etme
      }
      Modal.confirm({
        title: 'Referans durumunu güncellemek istiyor musunuz?',
        content: 'Evet dediğinizde Referans bilgileri güncellenecektir.',
        okText: 'Evet',
        cancelText: 'Hayır',
        onOk: async () => {
          try {
            const response = await requests.order.updateReferenceCode({
              id:selectedRowData.id,
              code: selectedRowData.code,
              name: selectedRowData.name,
              height: selectedRowData.height,
              width:selectedRowData.width,
              subDepartmentId: "6588e3b13feccdb13e955a47",
              kod: selectedRowData.kod,
              labelCategory: "YIKAMA TALİMATI",
              labelType: "YIKAMA TALİMATI",
              a: selectedRowData.a,
              backgroundColor: selectedRowData.backgroundColor,
              shape: '',
              shape2: ''
            })

            if (response.status === 200) {
              Modal.success({
                title: 'Başarılı',
                content: 'Sipariş başarıyla güncellendi.'
              })
              console.log("responseee",response.data.data);
              setGrafDurum(response.data.data) // Yeni veriyi tabloya ekle
              setGrafDurumOld(response.data.data) // Yeni veriyi tabloya ekle
              refetch(); // Refetch'i tetikle

            }
          } catch (error) {
            console.error('Hata oluştu:', error)
            Modal.error({
              title: 'Hata',
              content: 'Sipariş güncellenirken bir hata oluştu.'
            })
          }
        },
        onCancel() {
          console.log('Güncelleme iptal edildi.')
        }
      })
      // Örneğin, updateOrder fonksiyonuna gönderilebilir:

    
      setIsRowModalVisible(false); // Modalı kapat
    };
    
    const handleRowModalChange = (key, value) => {
      setSelectedRowData((prev) => ({ ...prev, [key]: value })); // Seçilen veriyi güncelle
    };
    return (
      <div>
        <Form
          form={form4}
          layout="horizontal"
          onFinish={onSipNoFinishGrafik}
          initialValues={{ radio: '1' }}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            position: 'relative',
            flexShrink: 1,
            boxSizing: 'border-box',
            overflow: 'hidden',
            width: 700
          }}
          labelAlign="left"
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-start',
              gap: '16px',
              width: '100%'
            }}
          >
            <Form.Item label="Kod:" name="code" style={{ width:"100%",margin:0,padding:0 }}>
              <AntInput placeholder="Kod girin" />
            </Form.Item>
            <Form.Item label="İsim:" name="name" style={{ width:"100%",margin:0,padding:0  }}>
              <AntInput placeholder="İsim" />
            </Form.Item>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", width: "100%" }}>
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      width: "50%",
      boxSizing: "border-box", // Eklenen box-sizing
      paddingTop:10,
    }}
  >
    <Form.Item label="Width:" name="width" style={{ width: "100%", margin: 0 }}>
      <AntInput placeholder="Width girin" />
    </Form.Item>
    <Form.Item label="Height:" name="height" style={{ width: "100%", marginTop: "10px",marginBottom:0}}>
      <AntInput placeholder="Height girin" />
    </Form.Item>
  </div>
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      width: "50%",
      boxSizing: "border-box", // Eklenen box-sizing
      paddingTop:10,

      paddingLeft:10
    }}
  >
    
              <Form.Item label="Renk" name="backgroundColor" style={{margin:0,width:"100%"}}>
            <ClearableSelect
              value={form4.getFieldValue('backgroundColor') || ''}
              onChange={(value) => form4.setFieldsValue({ backgroundColor: value })}
              options={colordsx.map((ilk) => ({
                value: ilk.code,
                label: ilk.text,
              }))}
              placeholder="Renk Seçin"
              form={form4}
              name="backgroundColor"
            />
          </Form.Item>
    <Form.Item label="A:" name="a" style={{ width: "100%", marginTop: "10px",marginBottom:0 }}>
      <AntInput placeholder="A" />
    </Form.Item>
  </div>

</div>

          <Form.Item label="Uzunkod:" name="kod" style={{ width: "50%", marginTop: "10px",marginBottom:10 }}>
      <AntInput placeholder="kod" />
    </Form.Item>

    <Form.Item>
            <AntButton
              htmlType="submit"
              style={{
                width: '100%',
                marginTop: 10,
                backgroundColor: 'green',
                color: 'white',
                paddingTop: 15,
                paddingBottom: 15,
                fontSize: 15
              }}
            >
              Kaydet
            </AntButton>
          </Form.Item>
  

          <div style={{ width: '100%' }}>
          <div style={{ width: '100%',display:"flex",flexDirection:"row",justifyContent:"flex-end" }}>
          <Form.Item>
          <AntInput
  placeholder="Ara"
  value={searchText}
  onChange={(e) => handleSearchmini(e.target.value)}
  onSearch={(value) => handleSearchmini(value)} // `onSearch` direkt `handleSearchmini` fonksiyonunu alabilir
  style={{ marginBottom: '0',width:"100%"}}
/>
</Form.Item>
</div>

            <Table
              columns={minicolumnsgrafikdurum}
              dataSource={GrafDurum} // Tablo verisi GrafDurum state'inden gelir
              rowKey="code"
              pagination={{ pageSize: 5 }}
              onRow={(record) => ({
                onClick: () => handleRowGrafDurumClick(record),

              })}
              components={{
    body: {
      row: (props) => (
        <tr {...props} style={{ height: '30px' }} /> // Satır yüksekliği burada ayarlanır
      ),
    },
  }}
            />
<Modal
  title="Referans Güncelle"
  visible={isRowModalVisible}
  onOk={handleRowModalSave}
  onCancel={() => setIsRowModalVisible(false)}
  okText="Güncelle" // "OK" yerine "Güncelle"
  cancelText="İptal" // "Cancel" yerine "İptal"
>
<Form 
  layout="inline" // Daha iyi düzen için "vertical"
  style={{ gap: '10px' }} // Form genel boşluk
>
  {/* Kod ve İsim Alanları Yan Yana */}
  <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '10px' }}>
    <Form.Item
      label="Kod"
      style={{ width:"50%" }}
    >
      <AntInput
        value={selectedRowData?.code || ""}
        onChange={(e) => handleRowModalChange("code", e.target.value)}
      />
    </Form.Item>
    <Form.Item
      label="İsim"
      style={{ width:"50%" }}
    >
      <AntInput
        value={selectedRowData?.name || ""}
        onChange={(e) => handleRowModalChange("name", e.target.value)}
      />
    </Form.Item>
  </div>

  {/* Genişlik ve Yükseklik Alanları Yan Yana */}
  <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '10px' }}>
    <Form.Item
      label="Genişlik"

      style={{ width:"50%" }}
    >
      <AntInput
        value={selectedRowData?.width || ""}
        onChange={(e) => handleRowModalChange("width", e.target.value)}
      />
    </Form.Item>
    <Form.Item
      label="Yükseklik"

      style={{ width:"50%" }}
    >
      <AntInput
        value={selectedRowData?.height || ""}
        onChange={(e) => handleRowModalChange("height", e.target.value)}
      />
    </Form.Item>
  </div>

  {/* Renk ve A Alanları Yan Yana */}
  <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '10px' }}>
    <Form.Item
      label="Renk"

      style={{ width:"50%" }}
    >
      <ClearableSelect
        value={selectedRowData?.backgroundColor || ''}
        onChange={(value) => handleRowModalChange("backgroundColor", value)}
        options={colordsx.map((ilk) => ({
          value: ilk.code,
          label: ilk.text,
        }))}
        placeholder="Renk Seçin"
      />
    </Form.Item>
    <Form.Item
      label="A"

      style={{ width:"50%" }}
    >
      <AntInput
        value={selectedRowData?.a || ""}
        onChange={(e) => handleRowModalChange("a", e.target.value)}
      />
    </Form.Item>
  </div>

  {/* Uzunkod */}
  <Form.Item 
    label="Uzunkod" 
    style={{ width:"100%" }}
  >
    <AntInput
      value={selectedRowData?.kod || ""}
      onChange={(e) => handleRowModalChange("kod", e.target.value)}
    />
  </Form.Item>
</Form>

</Modal>

          </div>
       
        </Form>
      </div>
    )
  }
  const handleButtonClick = () => {
    const errors = [] // Hata mesajlarını saklamak için bir dizi

    values.washingLabel.forEach((label, labelIndex) => {
      // Her bir fabric için aynı 'type' değerlerini kontrol et
      label.fabric.forEach((fabric, fabricIndex) => {
        const typeCounts = fabric.mix.reduce((acc, mix) => {
          acc[mix.type] = (acc[mix.type] || 0) + 1
          return acc
        }, {})

        // Eğer bir 'type' birden fazla kez bulunursa, hata mesajı ekle
        Object.entries(typeCounts).forEach(([type, count]) => {
          if (count > 1) {
            errors.push(
              `Yenilenen değerler '${type}' type found in Fabric ${fabricIndex + 1} of Label ${labelIndex + 1}.`
            )
          }
        })
      })
    })

    // Eğer hata mesajı varsa, uyarı göster ve işlemi durdur
    if (errors.length > 0) {
      toast.error(errors.join('\n'))
      return; // İşlemi durdurur
    }
    const incorrectOrderExists = values.washingLabel.some((label) =>
      label.fabric.some((fabric) =>
        fabric.mix.some(
          (mix, index, array) => index > 0 && Number(mix.percent) > Number(array[index - 1].percent)
        )
      )
    )

    if (incorrectOrderExists) {
  
      toast.error('Karışım yüzdeleri yanlış sıralandı: Sol taraftaki değer sağ taraftakinden büyük olmalıdır.')
      return ;
    }
    const exceedsHundred = values.washingLabel.some((label) =>
    label.fabric.some((fabric) => {
      const totalPercent = fabric.mix.reduce((sum, mix) => sum + Number(mix.percent), 0);
      return totalPercent !== 100;
    }) 
  );
  if(exceedsHundred)
  {
    toast.error('Karışım 100 den büyük veya küçükolamaz');
    return;
  }
 

    navigate(`/siparisler/artwork/${orderNo}?tab=${0}&zaratype=${brannd}`);
  };
  const handleSaveOrder = () => {

    const department = `${brand.split('_')[1]} / ${dept.split('_')[1]} / ${subDept}`
    const filteredValues = values.washingLabel.map((label) => {
      const filteredFabric = label.fabric.map((fabricItem) => {
        const filteredMix = fabricItem.mix.filter((mix) => mix.percent > 0)
        return { ...fabricItem, mix: filteredMix }
      })

      return { ...label, fabric: filteredFabric }
    })
    const path = `${brand}/${dept}/${subDept}`

    const errors = [] // Hata mesajlarını saklamak için bir dizi

    values.washingLabel.forEach((label, labelIndex) => {
      if(!label.colorCode || !label.referanceCode)
      {
        errors.push("Renk Kodu ve Referans Kodu Girilmek Zorunda")
      }
      
      // Label'da hiç oylanmış veri var mı kontrol et (percent > 0)
      const hasValidData = label.fabric.some((fabric) =>
        fabric.mix.some((mix) => Number(mix.percent) > 0)
      )
      
      if (!hasValidData) {
        errors.push(`Label ${labelIndex + 1}: En az bir kumaş karışımı yüzdesi girilmelidir (0'dan büyük olmalı)`)
      }

      // Her bir fabric için aynı 'type' değerlerini kontrol et
      label.fabric.forEach((fabric, fabricIndex) => {
        const typeCounts = fabric.mix.reduce((acc, mix) => {
          acc[mix.type] = (acc[mix.type] || 0) + 1
          return acc
        }, {})

        // Eğer bir 'type' birden fazla kez bulunursa, hata mesajı ekle
        Object.entries(typeCounts).forEach(([type, count]) => {
          if (count > 1) {
            errors.push(
              `Yenilenen değerler '${type}' type found in Fabric ${fabricIndex + 1} of Label ${labelIndex + 1}.`
            )
          }
        })
      })
    })

    // Eğer hata mesajı varsa, uyarı göster ve işlemi durdur
    if (errors.length > 0) {
      toast.error(errors.join('\n'))
      return; // İşlemi durdurur
    }
    const incorrectOrderExists = values.washingLabel.some((label) =>
      label.fabric.some((fabric) =>
        fabric.mix.some(
          (mix, index, array) => index > 0 && Number(mix.percent) > Number(array[index - 1].percent)
        )
      )
    )

    if (incorrectOrderExists) {
  
      toast.error('Karışım yüzdeleri yanlış sıralandı: Sol taraftaki değer sağ taraftakinden büyük olmalıdır.')
      return ;
    }
    const exceedsHundred = values.washingLabel.some((label) =>
    label.fabric.some((fabric) => {
      const totalPercent = fabric.mix.reduce((sum, mix) => sum + Number(mix.percent), 0);
      return totalPercent !== 100;
    }) 
  );
  if(exceedsHundred)
  {
    toast.error('Karışım 100 den büyük veya küçükolamaz');
    return;
  }
  if(errors.length === 0)
  {
    saveOrder({ ...values, washingLabel: filteredValues, brand: brandId, department, path })
  }
  }
  const hasDuplicateFabricTypes = () => {
    return values.washingLabel.some((label) => {
      const fabricTypes = label.fabric.flatMap((fabric) => fabric.mix.map((mix) => mix.type))
      const uniqueFabricTypes = new Set(fabricTypes)
      return uniqueFabricTypes.size !== fabricTypes.length
    })
  }

  const handleUpdateOrder = () => {
    const errors = [] // Hata mesajlarını saklamak için bir dizi

    values.washingLabel.forEach((label, labelIndex) => {
      console.log("foreachçi",label.colorCode)
      if(!label.colorCode || !label.referanceCode)
      {
        errors.push("Renk Kodu ve Referans Kodu Girilmek Zorunda")
      }
      // Her bir fabric için aynı 'type' değerlerini kontrol et
      label.fabric.forEach((fabric, fabricIndex) => {
        const typeCounts = fabric.mix.reduce((acc, mix) => {
          acc[mix.type] = (acc[mix.type] || 0) + 1
          return acc
        }, {})

        // Eğer bir 'type' birden fazla kez bulunursa, hata mesajı ekle
        Object.entries(typeCounts).forEach(([type, count]) => {
          if (count > 1) {
            errors.push(
              `Yenilenen değerler '${type}' type found in Fabric ${fabricIndex + 1} of Label ${labelIndex + 1}.`
            )
          }
        })
      })
    })

    // Eğer hata mesajı varsa, uyarı göster ve işlemi durdur
    if (errors.length > 0) {
      toast.error(errors.join('\n'))
      return // İşlemi durdurur
    }
    const incorrectOrderExists = values.washingLabel.some((label) =>
      label.fabric.some((fabric) =>
        fabric.mix.some(
          (mix, index, array) => index > 0 && Number(mix.percent) > Number(array[index - 1].percent)
        )
      )
    )
    const exceedsHundred = values.washingLabel.some((label) =>
    label.fabric.some((fabric) => {
      const totalPercent = fabric.mix.reduce((sum, mix) => sum + Number(mix.percent), 0);
      return totalPercent !== 100;
    }) 
  );
  if(exceedsHundred)
  {
    toast.error('Karışım 100 den büyük veya küçükolamaz');
    return;
  }
 

    if (incorrectOrderExists) {
  
      toast.error('Karışım yüzdeleri yanlış sıralandı: Sol taraftaki değer sağ taraftakinden büyük olmalıdır.')
      return // Yanlış sıralama varsa işlemi durdur.
    }
    console.log("güncellenen veriiiiiiiii",values.washingLabel)

    // Tekrar eden kumaş türü yoksa, güncelleme işlemini gerçekleştir
    const filteredValues = values.washingLabel.map((label) => {
      const filteredFabric = label.fabric.map((fabricItem) => {
        const filteredMix = fabricItem.mix.filter((mix) => mix.percent > 0)
        return { ...fabricItem, mix: filteredMix }
      })

      return { ...label, fabric: filteredFabric }
    })
    delete values.brandId
    if(errors.length === 0)
    {
    
       updateOrder({ id: orderNo, body: { ...values, washingLabel: filteredValues, brand: brandId } })

    }
    
  }

  return (
    <FieldArray name="washingLabel">
      {({ push, remove }) => (
        <div>
          {values.washingLabel.map((_, idx) => (
            <div className="grid grid-cols-2 gap-5 pb-5 relative" key={idx}>
              <div className="col-span-2 grid grid-cols-2 gap-2 rounded border border-dashed p-2">
            
                    <NoFormInput
                      label="Müşteri Sipariş No"
                      value={values.washingLabel[idx]?.customerOrderNo}
                      onChange={(e) => {
                        if (values.changesForEveryProduct) {
                          setFieldValue(`washingLabel[${idx}].customerOrderNo`, e.target.value)
                        }
                      
                      }}
                    />

                    <Input
                      label="Müşteri Sipariş Detayı"
                      name={`washingLabel[${idx}].customerOrderDetail`}
                      autoComplete="off"
                    />

                    <Input
                      label="Renk Kodu"
                      name={`washingLabel[${idx}].colorCode`}
                      maxLength="3"
                      autoComplete="off"
                    />

<DisliSayisiDetayModal
                  visible={isDisliModalVisible}
                  onCancel={handleDisliModalClose}
                  minWidth={'30%'} // modalType 4 ise minWidth 40%, aksi halde 30%
                  width={740}
                  title="Yıkama Etiketi Referans Ekle"
                >
                  <DrawerContent4 />
                </DisliSayisiDetayModal>

                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                  <div style={{ width: '75%' }}>
                  <div className={`${idx > 0 ? 'hidden' : ''}`}>
                      <SelectReferanceCode name={`washingLabel[${idx}].referanceCode`} />
                    </div>
           
                  </div>
                  {user.companyName === "Şimşek Ege Etiket ve Matbaacılık\nLimited Şirketi" && 
                    user.tierType === "ADMIN" && (
  <div style={{ width: '20%', overflow:'hidden', marginRight:0}}>
    <UIButton
      type="button"
      variant="blue"
      onClick={handleDisliModalOpen}
      style={{width:'100%'}}
    >
      Referans Ekle
    </UIButton>
  </div>
)}
                    <div style={{ width: '20%' }}>

                    {(values.beltLabel?.some(label => label?.sizes?.length > 0) || 
    values.priceLabel?.some(label => label?.sizes?.length > 0) || 
    values.brandLabel?.some(label => label?.sizes?.length > 0) ||
    values.zaraHomeLabel11?.some(label => label?.sizes?.length > 0) ||
    values.zaraHomeLabel12?.some(label => label?.sizes?.length > 0)) && (
      <UIButton
  type="button"
  style={{backgroundColor:'#b0059c'}}
  onClick={() => {
    const availableLabels = [];
    
    // Her kaynak tipindeki her colorCode için ayrı seçenek oluştur
    if (values.beltLabel?.some(label => label?.sizes?.length > 0)) {
      const beltLabels = values.beltLabel.filter(label => label?.sizes?.length > 0);
      beltLabels.forEach((label, idx) => {
        availableLabels.push({ 
          type: 'belt', 
          label: label,
          name: beltLabels.length > 1 ? `Kemer Kartı - ${label.colorCode || `Renk ${idx + 1}`}` : 'Kemer Kartı',
          colorCode: label.colorCode || ''
        });
      });
    }
    
    if (values.priceLabel?.some(label => label?.sizes?.length > 0)) {
      const priceLabels = values.priceLabel.filter(label => label?.sizes?.length > 0);
      priceLabels.forEach((label, idx) => {
        availableLabels.push({ 
          type: 'price', 
          label: label,
          name: priceLabels.length > 1 ? `Fiyat Etiketi - ${label.colorCode || `Renk ${idx + 1}`}` : 'Fiyat Etiketi',
          colorCode: label.colorCode || ''
        });
      });
    }
    
    if (values.brandLabel?.some(label => label?.sizes?.length > 0)) {
      const brandLabels = values.brandLabel.filter(label => label?.sizes?.length > 0);
      brandLabels.forEach((label, idx) => {
        availableLabels.push({ 
          type: 'brand', 
          label: label,
          name: brandLabels.length > 1 ? `Marka Kartı - ${label.colorCode || `Renk ${idx + 1}`}` : 'Marka Kartı',
          colorCode: label.colorCode || ''
        });
      });
    }
    
    if (values.zaraHomeLabel11?.some(label => label?.sizes?.length > 0)) {
      const zara11Labels = values.zaraHomeLabel11.filter(label => label?.sizes?.length > 0);
      zara11Labels.forEach((label, idx) => {
        availableLabels.push({ 
          type: 'zaraHome11', 
          label: label,
          name: zara11Labels.length > 1 ? `Zara Home Label 11 - ${label.colorCode || `Renk ${idx + 1}`}` : 'Zara Home Label 11',
          colorCode: label.colorCode || ''
        });
      });
    }
    
    if (values.zaraHomeLabel12?.some(label => label?.sizes?.length > 0)) {
      const zara12Labels = values.zaraHomeLabel12.filter(label => label?.sizes?.length > 0);
      zara12Labels.forEach((label, idx) => {
        availableLabels.push({ 
          type: 'zaraHome12', 
          label: label,
          name: zara12Labels.length > 1 ? `Zara Home Label 12 - ${label.colorCode || `Renk ${idx + 1}`}` : 'Zara Home Label 12',
          colorCode: label.colorCode || ''
        });
      });
    }

    if (availableLabels.length > 0) {
      let selectedIndex = null;

      // Tek seçenek varsa direkt kopyala
      if (availableLabels.length === 1) {
        const selectedItem = availableLabels[0];
        setFieldValue(`washingLabel[${idx}]`, {
          ...values.washingLabel[idx],
          sizeDefectivePercent: selectedItem.label.sizeDefectivePercent || '',
          sizes: selectedItem.label.sizes.map(size => ({
            ...size,
            amount: size.amount || '',
            amountWithDefect: size.amountWithDefect || ''
          }))
        });
        message.success(`${selectedItem.name}${selectedItem.colorCode ? ' - ' + selectedItem.colorCode : ''} bedenleri kopyalandı`);
      } else {
        // Birden fazla seçenek varsa modal göster
        Modal.confirm({
          title: 'Veri Kaynağını Seçin',
          content: (
            <Select 
              style={{ width: '100%' }} 
              placeholder="Kaynak seçin"
              onChange={(value) => { selectedIndex = value; }}
            >
              {availableLabels.map((item, itemIdx) => (
                <Select.Option key={itemIdx} value={itemIdx}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          ),
          onOk: () => {
            if (selectedIndex === null) {
              message.error('Lütfen bir kaynak seçin');
              return;
            }
            
            const selectedItem = availableLabels[selectedIndex];
            if (selectedItem && selectedItem.label) {
              setFieldValue(`washingLabel[${idx}]`, {
                ...values.washingLabel[idx],
                sizeDefectivePercent: selectedItem.label.sizeDefectivePercent || '',
                sizes: selectedItem.label.sizes.map(size => ({
                  ...size,
                  amount: size.amount || '',
                  amountWithDefect: size.amountWithDefect || ''
                }))
              });
              message.success(`${selectedItem.name}${selectedItem.colorCode ? ' - ' + selectedItem.colorCode : ''} bedenleri kopyalandı`);
            }
          }
        });
      }
    } else {
      message.warning('Kopyalanacak veri bulunamadı');
    }
  }}
  className="w-full"
>
  Oto Doldur
</UIButton>
  )}
  </div>
                  </div>
               
      
              </div>
              <div className="col-span-2 grid grid-cols-2 gap-x-5">
                {brannd === 'ZaraHome' ? (
                  <SizesHome idx={idx} setdepartmantIDD={setdepartmantIDD} setifinch={setifinch} ifinch={ifinch} />
                ) : (
                  <Sizes idx={idx} />
                )}
       
                  <div className={`${idx > 0 && 'hidden'}`}>
                    <Symbol brand={brannd} />
                    {/* Gramaj input'u sadece belirli referans gruplarında görünecek */}
                    {departmantIDD && (
                      <div className="mt-4">
                        <Input
                          label="Gramaj"
                          name={`washingLabel[${idx}].gramaj`}
                          type="number"
                          autoComplete="off"
                          placeholder="Gramaj değerini giriniz"
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            const gramajValue = e.target.value;
                            // Tüm renklere aynı gramaj değerini uygula
                            values.washingLabel.forEach((_, labelIdx) => {
                              setFieldValue(`washingLabel[${labelIdx}].gramaj`, gramajValue);
                            });
                          }}
                          min="0"
                          step="1"
                        />
                      </div>
                    )}

                    {departmantIDD && 
                     ['444', '222'].includes(departmantIDD) && (
                      <div className="mt-4">
                        <Input
                          label="Bag mm"
                          name={`washingLabel[${idx}].bagmm`}
                          type="number"
                          autoComplete="off"
                          placeholder="Bag mm değerini giriniz"
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            const bagmmValue = e.target.value;
                            // Tüm renklere aynı bagmm değerini uygula
                            values.washingLabel.forEach((_, labelIdx) => {
                              setFieldValue(`washingLabel[${labelIdx}].bagmm`, bagmmValue);
                            });
                          }}
                          min="0"
                          step="1"
                        />
                      </div>
                    )}
                  </div>
    
             

              </div>
              
                  <Fabric idx={idx} brrand={brannd} />
                  <div
                    className={`${
                      idx > 0 ? 'hidden' : ''
                    } col-span-2 grid grid-cols-2 gap-5 rounded border border-dashed p-2`}
                  >
                    <AdditionalInstructions idx={idx} />
                    <WashingAdditionalInstructions idx={idx} brrand={brannd} />
                  </div>
                  <Separator className="col-span-2 h-[5px] bg-simsek" />
                  {idx > 0 && (
                    <Button
                      variant="destructive"
                      onClick={() => remove(idx)}
                      className="absolute -right-40 top-0"
                    >
                      <X className="w-4 h-4 text-white" />
                      Renk Sil
                    </Button>
                  )}
            
     
            </div>
          ))}
          <div className="flex items-center gap-x-5">
            {!orderNo && (
              <Button
                type="submit"
                variant="softgreen"
                onClick={handleSaveOrder}
                disabled={isPending}
                className="w-full"
              >
                {isPending && <RotateCcw className="animate-spin mr-2" size={16} />}
                Kaydet
              </Button>
            )}
            <Button
              type="button"
              onClick={orderNo ? handleUpdateOrder : handleSaveOrder}
              disabled={isPending || isPendingUpdate}
              className="w-full"
              variant={orderNo && 'softgreen'}
            >
              {(isPending || isPendingUpdate) && (
                <RotateCcw className="animate-spin mr-2" size={16} />
              )}
              {orderNo ? 'Güncelle' : "Artwork'e Git"}
            </Button>
            {orderNo && (
              <Button
          type="button"
          disabled={isPending}
          className="w-full"
          onClick={handleButtonClick}
        >
          {isPending && <RotateCcw className="animate-spin mr-2" size={16} />}
          Artwork'e Git
        </Button>
            )}
            <Button
              type="button"
              variant="blue"
              onClick={() => {
                push({
                  ...values.washingLabel[0],
                  colorCode: '',
                  sizeDefectivePercent: '',
                  sizes: values.washingLabel[0].sizes.map((size) => ({
                    ...size,
                    amount: '',
                    amountWithDefect: ''
                  }))
                })
              }}
              className="w-full"
            >
              Renk Ekle
            </Button>
          </div>
        </div>
      )}
    </FieldArray>
  )
}
